import diff from 'microdiff'

export const getObjectDiff = (a: object, b: object) => {
  return diff(a, b)
}
